import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

export default function NewFilterButton({
  additionalClasses,
  children,
  container,
  containerClasses,
  disabled,
  filtersApplied,
  name,
  label,
  placement,
  style = {}
}) {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const [triggerWidth, setTriggerWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setTriggerWidth(containerRef.current.offsetWidth);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const renderPopover = () => (
    <Popover
      className={`${name} ds-popover`}
      id={name}
      style={{
        width: triggerWidth ? `${triggerWidth}px` : 'auto',
        maxWidth: 'none'
      }}
    >
      {children}
    </Popover>
  );

  const buttonClasses = `
    ds-filter-button d-flex align-items-center justify-content-between
    ${filtersApplied ? 'has-filters' : ''}
    ${additionalClasses}
  `;

  return (
    <div
      className={containerClasses}
      ref={containerRef}
      style={style}
    >
      <OverlayTrigger
        container={container}
        name={name}
        overlay={renderPopover()}
        placement={placement || 'bottom'}
        rootClose
        trigger={disabled ? [] : 'click'}
      >
        <button
          className={buttonClasses}
          ref={buttonRef}
          style={{ ...style, '--trigger-width': `${triggerWidth}px` }}
        >
          {typeof label === 'string' ? (
            <span className="ds-filter-text" ref={textRef}>{label}</span>
          ) : label}
          <FontAwesomeIcon icon={faChevronDown}/>
        </button>
      </OverlayTrigger>
    </div>
  );
}

NewFilterButton.propTypes = {
  additionalClasses: PropTypes.string,
  children: PropTypes.any.isRequired,
  container: PropTypes.any,
  containerClasses: PropTypes.string,
  disabled: PropTypes.bool,
  filtersApplied: PropTypes.bool,
  filterTag: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  name: PropTypes.string.isRequired,
  placement: PropTypes.string,
  selectedLength: PropTypes.number,
  style: PropTypes.object,
  onClear: PropTypes.func
};
